var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('psi-page-title',{attrs:{"title":_vm.page.title,"icon":_vm.page.icon,"breadcrumbs":_vm.breadcrumbs}}),_c('v-card',{staticClass:"mt-4"},[_c('v-card-text',[_c('application-list-wrapper',{attrs:{"title":"Applications"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }